import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  NativeSelect,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  fetchAttendances,
  attendanceOffice,
  fetchAvailableCommunicators,
} from "../../actions";
import { Content } from "../layout";
import { pageLimit as limit } from "../../config/keys";

const Attendance = () => {
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector(
    (state) => state.worker.attendances || { count: 0, rows: [] }
  );
  const communicators = useSelector(
    (state) => state.communicator.communicators
  );
  const { user } = useSelector((state) => state.auth);

  const communicatorRef = useRef([]);
  const repeaterRef = useRef([]);

  // useEffect(() => {
  //   communicatorRef.current.value = [];
  //   repeaterRef.current.value = [];
  //   dispatch(fetchAttendances({ page, limit }));
  // }, [dispatch, page]);

  useEffect(() => {
    if (user) {
      communicatorRef.current.value = [];
      repeaterRef.current.value = [];
      dispatch(fetchAttendances({ page, limit }));
    }
  }, [dispatch, user, page]);

  useEffect(() => {
    dispatch(fetchAvailableCommunicators());
  }, [dispatch]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleAttendance = (attendance, id) => {
    // console.log(attendance, id);
    dispatch(attendanceOffice({ attendance, id })).then(() =>
      dispatch(fetchAvailableCommunicators()).then(() => {
        communicatorRef.current.value = [];
        repeaterRef.current.value = [];
        dispatch(fetchAttendances(page, limit));
      })
    );
  };

  const handleGoOffice = (id) => {
    const communicator = communicatorRef.current.find(
      (item) => Number(item.dataset.id) === id
    );
    const CommunicatorId = communicator.value;
    if (!CommunicatorId) {
      alert("안전장비를 선택해주세요.");
      return;
    }

    const repeater = repeaterRef.current.find(
      (item) => Number(item.dataset.id) === id
    );
    const RepeaterDevEUI = repeater.value;
    if (!RepeaterDevEUI) {
      alert("작업장을 선택해주세요.");
      return;
    }

    const attendance = {
      CommunicatorId,
      RepeaterDevEUI,
      attended: true,
    };

    handleAttendance(attendance, id);
  };

  const handleLeaveOffice = (id) => {
    const { Communicator, Repeater } = rows.find(
      (item) => item.id === Number(id)
    ).Attendances[0];

    const attendance = {
      CommunicatorId: Communicator.id,
      RepeaterDevEUI: Repeater.devEUI,
      attended: false,
    };

    handleAttendance(attendance, id);
  };

  const renderState = (worker) => {
    if (!worker.Attendances.length) return <Box>-</Box>;
    const state = worker.Attendances[0].attended ? "출근" : "퇴근";
    const createdAt = moment(worker.Attendances[0].createdAt).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    return (
      <Box>
        {state} <Box>({createdAt})</Box>
      </Box>
    );
  };

  const renderWorkers = (props) => {
    return rows.map((worker) => {
      const isAttended =
        worker.Attendances.length && worker.Attendances[0].attended;
      // console.log(worker.id, "isAttended", isAttended);
      return (
        <TableRow
          key={worker.id}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          data-id={worker.id}
        >
          <TableCell>{worker.name}</TableCell>
          {/* <TableCell>{worker.Application.Organization.displayName}</TableCell> */}
          <TableCell>{worker.Application.description}</TableCell>
          <TableCell>{worker.WorkerLanguage.language}</TableCell>
          <TableCell>{worker.phone}</TableCell>
          <TableCell>
            <Box sx={{ display: isAttended ? "block" : "none" }}>
              {isAttended && worker.Attendances[0].Communicator.name}
            </Box>
            <NativeSelect
              sx={{ display: !isAttended ? "block" : "none" }}
              inputProps={{ "data-id": worker.id }}
              inputRef={(ref) => communicatorRef.current.push(ref)}
            >
              <option />
              {communicators.rows.map((communicator) => (
                <option key={communicator.id} value={communicator.id}>
                  {communicator.name}
                </option>
              ))}
            </NativeSelect>
          </TableCell>
          <TableCell>
            <Box sx={{ display: isAttended ? "block" : "none" }}>
              {isAttended && worker.Attendances[0].Repeater.description}
            </Box>
            <NativeSelect
              sx={{ display: !isAttended ? "block" : "none" }}
              inputProps={{ "data-id": worker.id }}
              inputRef={(ref) => repeaterRef.current.push(ref)}
            >
              <option />
              {worker.Application.Repeaters.map((repeater) => (
                <option key={repeater.devEUI} value={repeater.devEUI}>
                  {repeater.description}
                </option>
              ))}
            </NativeSelect>
          </TableCell>
          <TableCell>{renderState(worker)}</TableCell>
          <TableCell>
            {!worker.Attendances.length || !worker.Attendances[0].attended ? (
              <Button
                variant="contained"
                onClick={() => handleGoOffice(worker.id)}
              >
                출근
              </Button>
            ) : (
              <Button
                variant="contained"
                color="error"
                onClick={() => handleLeaveOffice(worker.id)}
              >
                퇴근
              </Button>
            )}
          </TableCell>
          {/* <TableCell>{new Date(worker.createdAt).toLocaleString()}</TableCell> */}
        </TableRow>
      );
    });
  };

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            출근부
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="worker-list table"
              sx={{
                // minWidth: 650,
                borderRight: 0,
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>이름</TableCell>
                  {/* <TableCell>건설사</TableCell> */}
                  <TableCell>협력사</TableCell>
                  <TableCell>언어</TableCell>
                  <TableCell>전화번호</TableCell>
                  <TableCell>안전장비</TableCell>
                  <TableCell>작업장</TableCell>
                  <TableCell>상태</TableCell>
                  <TableCell>출퇴근</TableCell>
                  {/* <TableCell>등록일시</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>{renderWorkers()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
    </Content>
  );
};

export default Attendance;
